import { tv } from 'tailwind-variants';

export const selectStyle = tv({
  slots: {
    base: 'group relative',
    btn: [
      'relative bg-white flex w-full cursor-pointer items-center gap-2 rounded-lg md:text-sm',
      'border border-solid border-stroke  py-3 pl-3 pr-8 text-left text-base font-medium',
      'focus:outline-none focus-visible:border-primary/25 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2',
      'data-[open]:border-primary/25',
      'group-data-[disabled]:cursor-not-allowed group-data-[disabled]:bg-black/10'
    ],
    value: 'block min-h-[20px] grow truncate',
    noItems: 'pb-2 pt-1 text-center opacity-50',
    prepend: 'pointer-events-none shrink-0',
    prependIcon: 'size-4',
    loader: 'size-5 shrink-0 text-primary',
    append: 'shrink-0',
    appendIcon: 'size-4',
    action:
      'pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2',
    actionIcon: 'size-5 text-muted',
    hintMessage:
      'invisible mt-0.5 h-4 pl-1 text-2xs group-focus-within:visible',
    optionsWrapper: [
      'absolute z-10 my-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg',
      ' ring-1 ring-black/5 focus:outline-none sm:text-sm'
    ],
    option: [
      'relative cursor-pointer select-none px-4 py-2 text-gray-900',
      'data-[focus]:bg-primary/5',
      'data-[selected]:bg-primary/10 data-[selected]:font-semibold',
      '[&>span]:block [&>span]:truncate'
    ]
  },
  variants: {
    dense: {
      true: {
        btn: 'py-1.5'
      }
    },
    visibleHint: {
      true: {
        hintMessage: 'visible'
      }
    },
    hasError: {
      true: {
        btn: '!border-error',
        hintMessage: 'text-error'
      }
    },
    prependIconClickable: {
      true: {
        prependIcon: 'cursor-pointer'
      }
    },
    position: {
      top: {
        optionsWrapper: 'bottom-full drop-shadow-xl'
      },
      bottom: ''
    },
    empty: {
      true: {
        value: 'text-black/50'
      }
    }
  }
});
